import appMenu from './menu-app';
import adminMenu from './menu-admin';
import customerMenu from './menu-customer';
import converstaionMenu from './menu-converstaion';
import wechatMenu from './meun-wechat';
import { isDefaultCon } from '@/env';

console.log('process.env.REACT_CON', isDefaultCon());
const menus = isDefaultCon()
    ? { appMenu, converstaionMenu, customerMenu, adminMenu, wechatMenu }
    : {
        appMenu,
        customerMenu,
        adminMenu,
        wechatMenu,
    };
// const menus = {
//     appMenu,
//     customerMenu,
//     adminMenu,
// };
// const menus = {appMenu, converstaionMenu, customerMenu, adminMenu};

export default menus;
